import React from "react";
import TLLogoLoader from "./TLLogoLoader";

const MissingPerspectiveUploadField = ({
  uploading = false,
  generating = false,
  onChange,
  accept = ".txt,.md,.csv,.json,.html,.htm,.pdf,.docx",
  idleLabel = "Upload or drop files",
  loadingLabel = "Reading files...",
  className = "",
}) => {
  const isActive = uploading || generating;

  return (
    <label
      className={`missing-perspective-upload-field${
        isActive ? " is-generating" : ""
      } ${className}`.trim()}
      aria-busy={isActive ? "true" : undefined}
    >
      {uploading ? (
        <TLLogoLoader
          label={null}
          size={16}
          layout="inline"
          className="missing-perspective-upload-field__loader"
        />
      ) : (
        <span className="missing-perspective-upload-field__icon" aria-hidden="true">
          <i className="fa fa-upload" aria-hidden="true" />
        </span>
      )}
      <span className="missing-perspective-upload-field__text">
        {uploading ? loadingLabel : idleLabel}
      </span>
      <input
        className="missing-perspective-upload-field__input"
        type="file"
        multiple
        accept={accept}
        onChange={onChange}
      />
    </label>
  );
};

export default MissingPerspectiveUploadField;
